import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function Reframe() {
  return <section className="py-20 px-6 bg-white" data-id="element-298">
      <div className="max-w-3xl mx-auto" data-id="element-299">
        <FadeIn data-id="element-300">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-301">
            Antes de seguir, necesito decirte algo importante
          </h2>
        </FadeIn>

        <div className="space-y-6 text-lg text-gray-700" data-id="element-302">
          <FadeIn data-id="element-303">
            <p className="text-xl font-bold text-brand-charcoal" data-id="element-304">
              No estás fallando como padre o madre.
            </p>
          </FadeIn>

          <FadeIn data-id="element-305">
            <p data-id="element-306">
              Estás usando herramientas que nunca fueron diseñadas para este
              momento.
            </p>
          </FadeIn>

          <FadeIn data-id="element-307">
            <p data-id="element-308">
              Nadie te enseñó qué hacer en los próximos 60 segundos cuando tu
              hijo ya explotó.
            </p>
          </FadeIn>

          <FadeIn data-id="element-309">
            <div className="bg-gray-50 rounded-2xl p-8 my-8" data-id="element-310">
              <div className="grid md:grid-cols-2 gap-8" data-id="element-311">
                <div data-id="element-312">
                  <p className="font-bold text-brand-charcoal mb-4" data-id="element-313">
                    Lo que SÍ te enseñaron:
                  </p>
                  <ul className="space-y-2" data-id="element-314">
                    <li className="flex items-center gap-2" data-id="element-315">
                      <span className="text-green-500" data-id="element-316">✔️</span> Corregir
                    </li>
                    <li className="flex items-center gap-2" data-id="element-317">
                      <span className="text-green-500" data-id="element-318">✔️</span> Poner límites
                    </li>
                    <li className="flex items-center gap-2" data-id="element-319">
                      <span className="text-green-500" data-id="element-320">✔️</span> Exigir respeto
                    </li>
                  </ul>
                </div>
                <div data-id="element-321">
                  <p className="font-bold text-brand-charcoal mb-4" data-id="element-322">
                    Lo que NADIE te enseñó:
                  </p>
                  <ul className="space-y-2" data-id="element-323">
                    <li className="flex items-start gap-2" data-id="element-324">
                      <span className="text-red-500 flex-shrink-0" data-id="element-325">❌</span>
                      <span data-id="element-326">
                        Qué hacer en los 60 segundos después de que ya explotó
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </FadeIn>

          <FadeIn data-id="element-327">
            <p className="font-medium" data-id="element-328">Así que improvisas.</p>
          </FadeIn>

          <FadeIn data-id="element-329">
            <div className="pl-6 space-y-3 border-l-4 border-brand-orange" data-id="element-330">
              <p data-id="element-331">Gritas porque no sabes qué más hacer.</p>
              <p data-id="element-332">Amenazas porque necesitas que pare ya.</p>
              <p data-id="element-333">
                Explicas y razonas con alguien que en ese momento no puede
                escucharte.
              </p>
            </div>
          </FadeIn>

          <FadeIn data-id="element-334">
            <p data-id="element-335">
              Y cuando pasa, sientes esa mezcla conocida de agotamiento,
              frustración y culpa.
            </p>
          </FadeIn>

          <FadeIn data-id="element-336">
            <div className="bg-brand-cream rounded-2xl p-8 text-center mt-10" data-id="element-337">
              <p className="text-2xl font-serif font-bold text-brand-charcoal mb-2" data-id="element-338">
                Eso no es un problema de voluntad.
              </p>
              <p className="text-2xl font-serif font-bold text-brand-orange mb-4" data-id="element-339">
                Es un problema de método.
              </p>
              <p className="text-xl text-gray-700" data-id="element-340">
                Y los métodos se aprenden.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}